import debug from 'bows';
import Tabs from '../_tabs';
import Excerpts from '../_excerpts';

const log = debug('subscribe');

class NewsFeatures {
	constructor(opts) {
		this.opts = opts;

		// this.newsEventsTabs = Array.from( document.querySelectorAll('.news-events') ).map( (node) => {
		// 	return new Tabs( node, {
		// 		activeClass   : 'news-events--active',
		// 		activeTabClass: 'news-events__tab--active',
		// 		activeNavClass: 'news-events__tab-nav--active',
		// 		tabs          : '.news-events__tab',
		// 		navs          : '.news-events__tab-nav button'
		// 	} );
		// } );

		this.excerpts = new Excerpts();
		this.excerpts.init();

		log(this);
	}
}

export default function( opts = {} ) {
	return new NewsFeatures(opts);
}
